module.exports = __webpack_public_path__ + "static/img/mineBg.f3f48459.png";